<template>
  <v-container class="pt-0 px-0">
    <v-subheader class="text-h5 px-0">Kompressorlogbuch
        <v-spacer></v-spacer>
        <v-btn class="mx-0" small fab dark :color="scanner_enabled ? 'secondary' : 'primary'" @click="initReaders">
            <v-icon dark>{{ scanner_enabled ? 'mdi-barcode-off' : 'mdi-barcode' }} </v-icon>
        </v-btn>
    </v-subheader>
    <v-form class="d-flex align-start mb-2" @submit.prevent="addManual">
        <v-text-field class="mr-2" label="Flaschennummer manuell erfassen" v-model="manual" dense hide-details="auto" outlined autocomplete="off"></v-text-field>
        <v-btn dark color="primary" height="40" :disabled="!manual.trim()" @click="addManual">
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </v-form>
    <v-overlay
        absolute
        opacity="0.85"
        :value="scanner_enabled"
    >
        <div class="d-flex justify-end">
            <v-btn v-if="scanner_enabled" class="mx-5" small fab dark color="secondary" @click="scanner_enabled = false">
                <v-icon dark>mdi-barcode-off</v-icon>
            </v-btn>
        </div>
        <StreamBarcodeReader
            v-if="scanner_enabled"
            @decode="onDecode"
            @loaded="onLoaded"
        ></StreamBarcodeReader>
    </v-overlay>
    <v-list dense>
        <v-subheader class="text-h6">
            Flaschen
            <v-spacer></v-spacer>
            <v-btn class="mx-0" dark color="primary" :disabled="items.length<=0" @click="save">
                Speichern
            </v-btn>
        </v-subheader>
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
          >
            <v-list-item-action>
                <v-btn small fab dark color="danger" @click="remove(i)">
                    <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-content>
              {{ item }}
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-snackbar
        v-model="snackbar"
        :color="snackbar_color"
        timeout="5000"
        bottom
         class="snackbar text-center"
        >
        {{ snackbar_text }}
        </v-snackbar>
  </v-container>
</template>

<script>

import StreamBarcodeReader from "@/components/BarcodeScanner.vue";
import beep from '@/mixins/beep';
import axios from 'axios';
import scanner from '@/mixins/scanner';
import emitter from '@/eventBus.js';

  export default {
    name: 'Kompressorlogbuch',
    components:{
        StreamBarcodeReader
    },
    mixins: [beep,scanner],
    data: () => ({
        settings:{},
        items:[],
        manual: "",
        snackbar: false,
        snackbar_color: "success",
        snackbar_text: "Speichern erfolgreich",
        scanner_enabled: false,
        prev_scan: '',
        num_same_scans: 0,
    }),
    created() {
        emitter.on('nfc-read', this.handleNFC);
    },
    beforeDestroy() {
        emitter.off('nfc-read', this.handleNFC);
    },
    mounted(){
        var s = localStorage.getItem("settings")
        if (s) this.settings =  JSON.parse(s);
        this.settings.barcodepruefung = this.settings.barcodepruefung || 2;

        //  Barcodescanner
        if (this.scanner){
            this.scanner.setScannerMode(scanner.SCANNER_MODE_TIME);
            this.scanner.on("scan", this.onScan);
        }
    },
    methods: {
        initReaders(){
            this.scanner_enabled = !this.scanner_enabled
            // Audio beim Tippen freischalten (Browser erlauben Ton erst nach Nutzeraktion)
            this.beep(0.01,2500,"sine",1)
            //emitter.emit('nfc-init')
        },
        handleNFC(data) {
            if (!data.text) return;
            if (this.items.indexOf(data.text)<0){
                this.items.push(data.text);
                this.beep(1,2500,"sine",50);
            }
        },
        addManual(){
            const nr = this.manual.trim();
            if (!nr) return;
            if (this.items.indexOf(nr)>=0){
                this.snackbar_text = "Flasche bereits in der Liste"
                this.snackbar_color = "warning"
                this.snackbar = true;
                return;
            }
            this.items.push(nr);
            this.manual = "";
        },
        remove(itemIdx){
            this.items.splice(itemIdx,1);
        },
        onScan(scandata){
            if (this.items.indexOf(scandata)<0){
                this.items.push(scandata);
                this.beep(1,2500,"sine",50);
            }
        },
        save(){

            axios({
                url: process.env.VUE_APP_APIURL+"kompressorlogbuch/save",
                data : {
                    flaschen:this.items
                }, 
                method: 'POST' })
            .then(result => {
                if (result.status=="200"){
                    this.snackbar_text = "Speichern erfolgreich"
                    this.snackbar_color = "success"
                    this.snackbar = true;
                    this.items = []
                }else{
                    this.snackbar_text = "Speichern fehlerhaft"
                    this.snackbar_color = "error"
                    this.snackbar = true;
                }
            })
            .catch(() => {
                    this.snackbar_text = "Speichern fehlerhaft"
                    this.snackbar_color = "error"
                    this.snackbar = true;
            });
        },
        onDecode (result) {
            if (result!=this.prev_scan){
                this.num_same_scans = 1;
            }else{
                this.num_same_scans++;
            }
            if (this.num_same_scans>=this.settings.barcodepruefung){
                if (this.items.indexOf(result)<0){
                    this.items.push(result);
                    this.beep(1,2500,"sine",150);
                    this.scanner_enabled = false;
                    setTimeout(() => {this.scanner_enabled = true},200);
                }else if (Date.now() - (this.last_dup_beep || 0) > 1500){
                    // bereits erfasst: tieferer Ton (gedrosselt, der Code bleibt ja im Bild)
                    this.last_dup_beep = Date.now();
                    this.beep(1,800,"sine",150);
                }
            }else{
                this.beep(0.5,3500,"sine",10);
            }
            this.prev_scan = result;
        },
        onLoaded () {
            console.log("loaded")
        }
    }
  }
</script>
<style scoped>
    .snackbar{
        text-align: center;
    }
</style>